import React from 'react';
import project1 from '../img/project-1.jpg';
import project2 from '../img/project-2.jpg';
import project3 from '../img/project-3.jpg';
import project4 from '../img/project-4.jpg';
import project5 from '../img/project-5.jpg';
import project6 from '../img/project-6.jpg';

const projects = [
  {
    image: project1,
    title: 'TMC Education (web)',
    project: 'https://tcmeducation.in/',
    subtitle: 'Web Analysis',
    description: 'Developed a responsive education portal for students to access courses and resources seamlessly across all devices.',
    delay: '.3s',
  },
  // {
  //   image: project2,
  //   title: 'Exyntra Web Application',
  //   project: 'https://exyntra.com/',
  //   subtitle: 'Cyber Security Core',
  //   description: 'A modern, responsive corporate website built to showcase Exyntra’s vision, services, and startup journey. Designed and developed with performance, scalability, and clean UI/UX at its core to reflect the company’s innovative spirit.',
  //   delay: '.5s',
  // },
  {
    image: project3,
    title: 'Riyadh Holding – Corporate Website',
    project: 'https://www.riyadhholding.sa/',
    subtitle: 'Upcoming Phone',
    description: 'A bilingual, corporate website designed for one of Saudi Arabia’s leading infrastructure and real estate firms.Built to reflect the company’s legacy, vision, and impact on urban development in Riyadh.Features include responsive design, project showcase, and dual-language support.',
    delay: '.7s',
  },
  {
    image: project4,
    title: 'Education Point Naini Website ',
    project: 'https://www.educationpointnaini.in/',
    subtitle: 'Web Analysis',
    description: ' A dynamic online platform created for a career-mapping consultancy dedicated to simplifying student admissions.Showcases a team-driven vision, highlights 50+ certified courses, and emphasizes support for over 30,000 enrolled students.',
    delay: '.3s',
  },
  {
    image: project5,
    title: 'iamyourstory',
    subtitle: 'Marketing Analysis',
    project: 'https://iamyourstory.in/',
    description: ' A collaborative digital storytelling platform that empowers creatives to co-create narratives by combining writing, audio, and video elements.Designed with seamless user interactions, it enables contributors to build rich multimedia stories together — enhancing engagement across formats.',
    delay: '.5s',
  },
  {
    image: project6,
    title: 'Vlmorah',
    subtitle: 'Keyword Analysis',
    project: 'https://vlmorah.com',
    description: 'A modern eCommerce platform for premium indoor and outdoor furniture, offering stylish, durable, and space-conscious designs.Built for seamless browsing and checkout, the site features curated collections, responsive design, and an intuitive user experience.',
    delay: '.7s',
  },
];


const Project = () => {
  return (
    <div className="container-fluid project py-5 mb-5">
      <div className="container">
        <div className="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style={{ maxWidth: 600 }}>
          <h5 className="text-primary">Our Project</h5>
          <h1>Our Recently Completed Projects</h1>
        </div>
        <div className="row g-5">
          {projects.map((proj, index) => (
            <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay={proj.delay} key={index}>
              <div className="card h-100 shadow-sm border-0">
                <img src={proj.image} className="card-img-top rounded-top" alt={proj.title} />
                <div className="card-body text-center">
                  <h5 className="card-title">{proj.title}</h5>
                  <p className="card-text text-muted">{proj.description}</p>
                </div>
                <div className="card-footer bg-white border-0 text-center pb-4">
                  <a
                    href={proj.project.startsWith('http') ? proj.project : `https://${proj.project}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-sm px-4"
                  >
                    View Demo
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
